import DocumentV2 from "./DocumentV2";

export default DocumentV2;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/index.js